import React from 'react';
import { Home } from '@components';

const HomePage = () => {
  return (
    <Home />
  );
}

export default HomePage;